import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-nica-popup-pdf',
  templateUrl: './nica-popup-pdf.component.html',
  styleUrls: ['./nica-popup-pdf.component.css']
})
export class NicaPopupPdfComponent implements OnInit {
  @Input() file: File | undefined
  private pdfUrl: SafeResourceUrl | undefined;
  constructor(private readonly sanitizer: DomSanitizer) { }
  get url(): SafeResourceUrl {
    return this.pdfUrl;
  }
  ngOnInit(): void {
    if (this.file) {
      const blob = new Blob([this.file], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }
}